import { createContext } from "react";

interface RequestACallInterface {
    handleOpen?: () => void;
}

const RequestACallContext = createContext<RequestACallInterface>({});

export default RequestACallContext;